import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { getCookie } from 'utils/CookieHelpers'
import { NEVER_SHOW, HIDE_INTEGRATION_NOTICE } from './constants'

import TrialMessaging from './components/TrialMessaging'
import WidgetStatusTease from './components/WidgetStatusTease'
import EnableNotifications from './components/EnableNotifications'
import InstallDriftNotice from './components/InstallDriftNotice'
import EnableSound from './components/EnableSound'
import * as UserPropertiesSelectors from 'app/modules/user/properties/selectors'


import ACCESS from 'utils/Access'
import { properties } from 'app/modules/org/selectors'

require('./style.styl')

const NOTIFICATION_TYPES = {
  trial: TrialMessaging,
  widgetStatus: WidgetStatusTease,
  notifications: EnableNotifications,
  installDriftNotice: InstallDriftNotice,
  sound: EnableSound,
}

const startSound = new Audio(require(`audio/silence.mp3`))
startSound.muted = true

class GlobalNotificationBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      trialNudge: getCookie('DriftTrialDaily'),
      sound: 'default'
    }
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    app: PropTypes.object.isRequired,
  }

  static propTypes = {
    orgProperties: PropTypes.object.isRequired,
  }

  playStartSoundOnClick = () => {
    startSound.play().catch(function(error) {
      // Sound should definitely be able to play after user interaction, surface error to user through log
      console.info('Sound still unable to play after user interaction:');
      console.info(error)
    })
    this.setState({ sound: this.state.sound === 'failed' ? 'enabled' : 'confirmed'}) 
    // remove this listener to prevent subsequent unnecessary plays
    document.removeEventListener('click', this.playStartSoundOnClick)
  }

  componentWillMount() {
    //// Play an initial silent + muted sound to overcome browser autoplay policies
    // See https://goo.gl/xX8pDD for details on Chrome
    startSound.play().catch(() => {
      // The user interaction requirement is met on click so play our initial sound then
      document.addEventListener("click", this.playStartSoundOnClick)
      setTimeout(() => {
        this.setState({sound: this.state.sound === 'confirmed' ? 'confirmed' : 'failed'})
      }, 10000)

    })
  }

  hasBeenPromptedForClick = () => {
    return this.state.sound !== 'default' && this.state.sound !== 'confirmed'
  }

  hasRequestedSound = () => {
    return this.props.settings['humane-notifications-browser'] !== 'nothing' &&
    (this.props.settings['humane-notifications-browser-sound'] &&
     this.props.settings['humane-notifications-browser-sound'] !== 'none')
  }

  hasNotificationPermissionsGranted = () => {
    return window.Notification && window.Notification.permission === 'granted'
  }

  isOnTeamSettingsPage = () => {
    const { currentPath } = this.props
    return currentPath === '/settings/team'
  }

  isOnboarding = () => {
    const { currentPath } = this.props
    return (
      currentPath.includes('/welcome') || currentPath.includes('/setup') || currentPath.includes('install')
    )
  }

  selectNotificationType = () => {
    const { query } = this.context.location
    if (query.overrideNotification) {
      return NOTIFICATION_TYPES[query.overrideNotification]
    }

    if (
      this.props.orgProperties.widgetInstalled != true
    ) {
      return NOTIFICATION_TYPES.installDriftNotice
    }

    const {
      orgProperties: { trialExpiresAt },
    } = this.props
    const { trialNudge } = this.state

    if (ACCESS.hasGates('premium_team_trial') && trialExpiresAt) {
      const expirationMoment = moment(+trialExpiresAt)
      if (expirationMoment.isBefore() || !trialNudge) {
        return NOTIFICATION_TYPES.trial
      }
    }
    
    if (this.shouldShowNotificationsEnable()) {
      return NOTIFICATION_TYPES.notifications
    }
    
    if (this.shouldShowSoundEnable()) {
      return NOTIFICATION_TYPES.sound
    }

    return NOTIFICATION_TYPES.widgetStatus
  }

  shouldShowNotificationsEnable = () => {
    const { pathname } = this.context.location
    const hasntDissmissedForever = !window.localStorage.getItem(NEVER_SHOW)

    return (
      hasntDissmissedForever &&
      (window.Notification && window.Notification.permission === 'default' && pathname.includes('inboxes'))
    )
  }

  shouldShowSoundEnable = () => {
    const { pathname } = this.context.location  
    return (
      this.hasBeenPromptedForClick() &&
      this.hasRequestedSound() &&
      this.hasNotificationPermissionsGranted() && 
      pathname.includes('inboxes')
    )
  }

  render() {
    if (this.isOnboarding()) {
      return <div />
    }

    const NotificationComponent = this.selectNotificationType()
    return (
      <div className="notification-bar-wrapper">
        {NotificationComponent && <NotificationComponent {...this.props} {...this.context} sound={this.state.sound}/>}
      </div>
    )
  }
}

function mapStateToProps(state) {
  const settings = UserPropertiesSelectors.properties(state)
  return {
    orgProperties: properties(state),
    settings: settings && settings.toJS(),
  }
}

export default connect(mapStateToProps)(GlobalNotificationBar)



// WEBPACK FOOTER //
// ./src/scripts/components/GlobalNotificationBar/index.js